import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let modulesMountPromise = null;

export function initModulesViewFragment({ onMounted } = {}) {
  registerViewMount('admin-modules', () => mountModulesView(onMounted));
}

async function mountModulesView(onMounted) {
  if (document.getElementById('view-admin-modules')) return;
  if (modulesMountPromise) return modulesMountPromise;

  modulesMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/modules.html', 'Unable to load modules admin view');
    onMounted?.();
  })();

  try {
    await modulesMountPromise;
  } catch (error) {
    modulesMountPromise = null;
    throw error;
  }
}
